/* ===== NorthRidge PowerFit (slug: northpower) =====
   Interacciones de la landing + integración Releasit COD.

   Producto con 9 variantes reales: COLOR x TALLA (sin opción CANTIDAD).
   Cada variante mapea 1:1 con su variación en Dropi (Dropi solo tiene 9
   variaciones color/talla; no admite una 2da variante por combo, por eso el
   bundle NO puede ser variante aparte — ver memoria dropi-resku 2026-06-11).
   - Tier "1 Camiseta": la variante color/talla, qty 1 -> $79.900.
   - Tier "2+1 Gratis": la MISMA variante color/talla, qty 3. Un descuento
     automático de Shopify (mín. 3 uds del producto, −$89.800) baja el total a
     $149.900. El pedido llega a Dropi como "Color/Talla ×3" -> despacha 3 uds
     reales. Releasit lee input[name="quantity"] del DOM al disparar COD.
   La variante se resuelve por (color, talla) leyendo window.NX_VARIANTS que la
   section imprime desde product.variants — robusto al re-SKU de Dropi. */

(function () {
  'use strict';

  var root = document.querySelector('.northpower-landing');
  if (!root) return;

  /* ---------- galería: thumbs clickables + swap del hero + lightbox ---------- */
  var heroImg = document.getElementById('nx-hero-img');
  var thumbs = root.querySelectorAll('.nx-thumb');
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      var img = t.querySelector('img');
      if (!img || !heroImg) return;
      heroImg.src = img.src;
      thumbs.forEach(function (x) { x.classList.remove('sel'); });
      t.classList.add('sel');
    });
  });

  var lb = document.getElementById('nx-lightbox');
  var lbImg = document.getElementById('nx-lightbox-img');
  function openLightbox(src) { if (lb && lbImg) { lbImg.src = src; lb.classList.add('open'); } }
  function closeLightbox() { if (lb) lb.classList.remove('open'); }
  var heroBox = root.querySelector('.nx-hero-main');
  if (heroBox && heroImg) heroBox.addEventListener('click', function () { openLightbox(heroImg.src); });
  if (lb) lb.addEventListener('click', closeLightbox);
  window.nxCloseLightbox = closeLightbox;

  window.scrollThumbs = function (d) {
    var s = document.getElementById('nx-thumbs');
    if (s) s.scrollBy({ left: d * 140, behavior: 'smooth' });
  };

  /* ---------- sonido UGC ---------- */
  window.nxToggleSound = function (btn) {
    var v = btn.parentElement.querySelector('video');
    var mute = !v.muted;
    root.querySelectorAll('.nx-ugc video').forEach(function (o) { o.muted = true; });
    root.querySelectorAll('.nx-ugc .sound').forEach(function (b) { b.innerHTML = '🔇 Toca para oír'; });
    v.muted = mute;
    if (!mute) { v.play(); btn.innerHTML = '🔊 Sonido activo'; }
    else { btn.innerHTML = '🔇 Toca para oír'; }
  };

  /* ====================== Releasit COD ====================== */
  var RELEASIT_SELECTORS = [
    '#rsi_buy_now_button',
    '.rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '._rsi-buy-now-button-app-block-hook a',
    '.rsi-btn-skel'
  ];
  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var el = document.querySelector(RELEASIT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  // Releasit lee input[name="quantity"] del DOM al disparar COD (verificado).
  function setVariantOnAllForms(variantId, qty) {
    if (!variantId) return;
    var q = parseInt(qty, 10); if (!q || q < 1) q = 1;
    document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (i) { i.value = variantId; });
    document.querySelectorAll('input[name="product-id"]').forEach(function (i) { i.value = variantId; });
    document.querySelectorAll('input[name="quantity"]').forEach(function (i) { i.value = String(q); i.setAttribute('value', String(q)); });
    if (window.productData) { window.productData.quantity = q; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  /* ---------- estado de selección (bundle + color + talla) ---------- */
  var VARIANTS = Array.isArray(window.NX_VARIANTS) ? window.NX_VARIANTS : [];
  var selBundle = '2+1 Gratis';   // arranca en el más vendido (opt2)
  var selColor = null, selTalla = null;

  var elColor = document.getElementById('nx-color');
  var elTalla = document.getElementById('nx-talla');
  var elSold = document.getElementById('nx-soldout');
  var elSingle = document.getElementById('nx-sel-single');
  var elMulti = document.getElementById('nx-multi');
  var stickyPrice = document.getElementById('nx-sticky-price');

  if (elColor) selColor = elColor.value;
  if (elTalla) selTalla = elTalla.value;

  // Hay UNA sola variante por color/talla (la que Dropi mapea 1:1).
  function findVar(color, talla) {
    return VARIANTS.find(function (v) {
      return v.color === color && v.talla === talla;
    });
  }

  // Tier y cantidad según el bundle elegido — SIEMPRE la misma variante color/talla:
  //  - "1 Camiseta": qty 1 → $79.900.
  //  - "2+1 Gratis": qty 3 → descuento automático (−$89.800) deja el total en
  //    $149.900 y el pedido lleva 3 unidades reales (Dropi despacha 3).
  // El stepper de cantidad de Releasit está oculto (quantityControlsHidden:true),
  // así que el cliente no puede cambiar el 3 → el total siempre es correcto.
  function currentVariant() {
    return findVar(selColor, selTalla);
  }
  function currentQty() {
    return selBundle === '2+1 Gratis' ? 3 : 1;
  }

  function refresh() {
    var v = currentVariant();
    if (v) {
      setVariantOnAllForms(v.id, currentQty());
      if (elSold) elSold.style.display = v.available ? 'none' : 'block';
    } else if (elSold) {
      elSold.style.display = 'none';
    }
    if (stickyPrice) stickyPrice.textContent = selBundle === '2+1 Gratis' ? '$149.900' : '$79.900';
  }

  // selector de bundle (radios)
  window.nxSelOpt = function (n) {
    var o1 = document.getElementById('nx-opt1'), o2 = document.getElementById('nx-opt2');
    if (o1) o1.classList.toggle('sel', n === 1);
    if (o2) o2.classList.toggle('sel', n === 2);
    selBundle = (n === 2) ? '2+1 Gratis' : '1 Camiseta';
    refresh();
  };

  if (elColor) elColor.addEventListener('change', function () { selColor = elColor.value; refresh(); });
  if (elTalla) elTalla.addEventListener('change', function () { selTalla = elTalla.value; refresh(); });

  refresh(); // init

  function clickNativeReleasit() {
    var rb = findReleasitButton();
    if (rb) { rb.click(); return; }
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      var b = findReleasitButton();
      if (b) { clearInterval(poll); b.click(); return; }
      if (attempts > 30) {
        clearInterval(poll);
        if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
          try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
        }
      }
    }, 100);
  }

  window.northpowerTriggerCOD = function (btn) {
    var v = currentVariant();
    if (!v) { alert('Elige color y talla.'); return; }
    if (!v.available) { if (elSold) elSold.style.display = 'block'; return; }
    setVariantOnAllForms(v.id, currentQty());
    setTimeout(clickNativeReleasit, 50);
  };
  // alias usado por varios CTA/íconos
  window.openCart = function () { window.northpowerTriggerCOD(); };

  /* ---------- barra sticky móvil ---------- */
  (function () {
    var bar = document.getElementById('nx-sticky');
    var hero = root.querySelector('.nx-hero-main');
    if (!bar || !hero) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { bar.classList.toggle('show', !e.isIntersecting); });
    }, { rootMargin: '0px', threshold: 0 });
    io.observe(hero);
  })();

  /* ---------- guía de tallas (scroll a detalles) ---------- */
  window.nxSizeGuide = function () {
    var t = document.getElementById('nx-detalles');
    if (t) { t.setAttribute('open', ''); t.scrollIntoView({ behavior: 'smooth' }); }
  };

  /* ---------- spin to win ---------- */
  var spinShown = false;
  function showSpin() { if (spinShown) return; spinShown = true; var s = document.getElementById('nx-spin'); if (s) s.classList.add('open'); }
  window.nxCloseSpin = function () { var s = document.getElementById('nx-spin'); if (s) s.classList.remove('open'); };
  setTimeout(showSpin, 8000);
  document.addEventListener('mouseout', function (e) { if (e.clientY <= 0) showSpin(); });
  window.nxSpinWheel = function () {
    var w = document.getElementById('nx-wheel');
    if (w) w.style.transform = 'rotate(' + (1440 + 252) + 'deg)';
    setTimeout(function () { alert('¡Ganaste un descuento! Revisa tu correo.'); window.nxCloseSpin(); }, 3200);
  };

  /* ---------- modal de reseñas ---------- */
  var pickedStars = 5;
  window.nxOpenModal = function () { var m = document.getElementById('nx-modal'); if (m) m.classList.add('open'); };
  window.nxCloseModal = function () { var m = document.getElementById('nx-modal'); if (m) m.classList.remove('open'); };
  root.querySelectorAll('#nx-starpick b').forEach(function (b) {
    b.classList.add('on');
    b.addEventListener('click', function () {
      pickedStars = +b.dataset.v;
      root.querySelectorAll('#nx-starpick b').forEach(function (x) { x.classList.toggle('on', +x.dataset.v <= pickedStars); });
    });
  });
  window.nxSubmitReview = function () {
    var n = (document.getElementById('nx-rvName') || {}).value || 'Anónimo';
    var t = (document.getElementById('nx-rvText') || {}).value || '';
    var el = document.createElement('div');
    el.className = 'nx-review';
    el.innerHTML = '<div class="top"><div class="ini">' + n.slice(0, 1).toUpperCase() +
      '</div><div><b>' + n + '</b><span class="v">✔ Verificado</span></div><span class="date">ahora</span></div><p>' +
      t.replace(/</g, '&lt;') + '</p>';
    var list = document.getElementById('nx-reviewList');
    if (list) list.insertBefore(el, list.firstChild);
    window.nxCloseModal();
    if (document.getElementById('nx-rvText')) document.getElementById('nx-rvText').value = '';
    if (document.getElementById('nx-rvName')) document.getElementById('nx-rvName').value = '';
  };
})();
